// extracted by mini-css-extract-plugin
module.exports = {"component":"style_component__FWZTp","arrow":"style_arrow__kGx3k","slider":"style_slider__eXOcv","card":"style_card__Evu8A"};